import { camelizeKeys } from 'humps';

import { WniAppInfo, WniAppInfoKeys } from '../wni-app-info';
import { getAppInfoFromNative } from './get-app-info-from-native';

/**
 * native에서 wni를 통해 appInfo를 받아와 sessionStorage에 저장합니다.
 */
export const setWniAppInfoToStorage = async () => {
  const appInfo = await getAppInfoFromNative();
  const camelizeAppInfo = camelizeKeys(appInfo) as WniAppInfo;

  saveWniAppInfoToStorage(camelizeAppInfo);
};

/**
 * sessionStorage에 WniAppINfo를 저장합니다.
 */
export const saveWniAppInfoToStorage = (appInfo: WniAppInfo): void => {
  const camelizeAppInfo = camelizeKeys(appInfo) as WniAppInfo;

  Object.keys(camelizeAppInfo).forEach(key => {
    const prevAppInfoValue = sessionStorage.getItem(key) ?? '';
    const currentAppInfoValue = camelizeAppInfo[key as WniAppInfoKeys];

    // 기존에 저장된 값이 없을 경우 새로운 값을 저장 합니다.
    if (!prevAppInfoValue) {
      sessionStorage.setItem(key, JSON.stringify(currentAppInfoValue));
    }

    // 신규 값이 유효한 값이면 업데이트를, 아니라면 기존 값을 그대로 사용합니다.
    if (!currentAppInfoValue) {
      return;
    }

    if (prevAppInfoValue === currentAppInfoValue) {
      return;
    }

    sessionStorage.setItem(key, JSON.stringify(currentAppInfoValue));
  });
};
